import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); navigate("/admin"); } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0F19] flex flex-col items-center justify-center p-6">
      <Link to="/" className="text-zinc-400 text-sm inline-flex items-center gap-1 hover:text-white mb-8 transition-colors"><ArrowLeft size={14} /> Retour au site</Link>
      <div className="w-full max-w-md bg-white shadow-2xl">
        <div className="bg-red-600 text-white p-6">
          <div className="font-heading text-3xl font-black">Chronique<span className="text-[#111827]">.cd</span></div>
          <div className="flex items-center gap-2 mt-2 text-xs uppercase tracking-widest font-bold text-red-100"><Lock size={12} /> Administration</div>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4" data-testid="admin-login-form">
          <p className="text-sm text-zinc-600">Espace réservé à l'équipe du média. Connectez-vous pour gérer les contenus.</p>
          <div className="space-y-1.5"><Label htmlFor="email">E-mail</Label><Input id="email" data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none" /></div>
          <div className="space-y-1.5"><Label htmlFor="password">Mot de passe</Label><Input id="password" data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none" /></div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 p-2">{error}</p>}
          <Button data-testid="admin-login-submit" disabled={loading} className="w-full bg-[#111827] hover:bg-black rounded-none font-bold uppercase text-xs tracking-wider h-11">{loading ? "Connexion…" : "Se connecter"}</Button>
        </form>
      </div>
    </div>
  );
}
